import { NgModule } from '@angular/core';
import { CfCoreComponentModule, CfComponentsModule } from './components/component-modules';
import { CfServicesModule } from './services/services-module';
export class CfCoreModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfServicesModule
  ],
  declarations: [],
  entryComponents: [],
  providers: [],
  exports: [],
  schemas: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfCoreModule_tsickle_Closure_declarations() {
/** @type {?} */
CfCoreModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfCoreModule.ctorParameters;
}

export class CfModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreModule,
    CfComponentsModule
  ],
  declarations: [],
  entryComponents: [],
  providers: [],
  exports: [],
  schemas: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfModule_tsickle_Closure_declarations() {
/** @type {?} */
CfModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
